// @flow
import HR from './HR'

export default HR
